module.exports = __webpack_public_path__ + "img/ship_cost.8288454c.svg";